// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.white,
    borderRadius: theme.other.spacing._8,
    width: '600px',
    height: 'auto',
    maxHeight: '90vh',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',

    [theme.fn.smallerThan('sm')]: {
      width: '100%',
      height: '100vh',
      maxHeight: '100vh',
      borderRadius: 0,
    },
  },
  header: {
    backgroundColor: theme.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: theme.other.spacing._8,
    paddingBottom: theme.other.spacing._16,
    paddingLeft: 0,
    paddingRight: 0,
    width: '100%',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  headerTop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.other.spacing._8,
    paddingLeft: theme.other.spacing._8,
    paddingRight: theme.other.spacing._8,
    paddingTop: 0,
    paddingBottom: 0,
    width: '100%',
    boxSizing: 'border-box',
  },
  counterContainer: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    width: 130,
    justifyContent: 'flex-start',
    paddingLeft: theme.other.spacing._16,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._2,
    flexShrink: 0,
    flex: 1,
  },
  title: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 900,
    fontSize: '16px',
    lineHeight: '25px',
    color: theme.colors.gray2[6],
    textAlign: 'center',
    margin: 0,
  },
  emptySpace: {
    flexShrink: 0,
    width: 130,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
    alignItems: 'stretch',
    paddingLeft: theme.other.spacing._24,
    paddingRight: theme.other.spacing._24,
    paddingTop: theme.other.spacing._16,
    paddingBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 88, // Space for footer - keeping as number since it's a specific layout value
    width: '100%',
    color: theme.colors.gray2[3],
    position: 'relative',
    flex: 1,
    overflowY: 'auto',
    minHeight: 0, // Important for flex children to respect overflow

    [theme.fn.smallerThan('sm')]: {
      paddingBottom: theme.other.spacing._16,
    },
  },
  footer: {
    bottom: 0,
    left: 0,
    width: '600px',
    height: '72px',
    backgroundColor: theme.white,
    borderTop: `1px solid ${theme.colors.gray2[0]}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: theme.other.spacing._16,
    paddingRight: theme.other.spacing._16,
    boxSizing: 'border-box',
    flexShrink: 0,

    [theme.fn.smallerThan('sm')]: {
      width: '100%',
    },
  },
  notificationToggle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
  },
  checkbox: {
    width: theme.other.spacing._16,
    height: theme.other.spacing._16,
    border: `1.5px solid ${theme.colors.gray[6]}`,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ '3.2px',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    position: 'relative',

    '&:checked': {
      backgroundColor: theme.colors.teal[5],
      borderColor: theme.colors.teal[5],
    },
  },
  checkboxLabel: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.colors.gray[6],
    cursor: 'pointer',
    userSelect: 'none',
  },
  titleInput: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '32px',
    width: '100%',
    color: theme.colors.gray2[6],
    padding: 0,
    margin: 0,
    border: 'none',
    backgroundColor: 'transparent',
    '&::placeholder': {
      color: theme.colors.gray2[3],
      fontSize: '24px',
      fontWeight: 600,
    },
  },
  contentTextarea: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '22px',
    color: theme.colors.gray2[6],
    padding: 0,
    margin: 0,
    width: '100%',
    border: 'none',
    backgroundColor: 'transparent',
    '&::placeholder': {
      color: theme.colors.gray2[3],
      fontSize: '16px',
      fontWeight: 500,
    },
  },
  textareaWrapper: {
    width: '100%',
  },
  postButton: {
    minWidth: '80px',
  },
}));
